import React from "react";
import { Navigate } from "react-router-dom";
import { useUserAuth } from "../Context/UseAuthContext";
const ProtectedRoute1 = ({ children }) => {
  const { currentUser } = useUserAuth();

  console.log("Check user in Private: ", currentUser);
  if (!currentUser) {
    return <Navigate to="/start" />;
  }
  return children;
};

export default ProtectedRoute1;
